import { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './types';

// The initial state of the Alert container
export const initialState: ContainerState = {
  open: false,
  severity: undefined,
  message: undefined
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    success(state, action: PayloadAction<string>) {
      state.open = true;
      state.severity = 'success';
      state.message = action.payload;
    },
    error(state, action: PayloadAction<string>) {
      state.open = true;
      state.severity = 'error';
      state.message = action.payload;
    },
    warning(state, action: PayloadAction<string>) {
      state.open = true;
      state.severity = 'warning';
      state.message = action.payload;
    },
    info(state, action: PayloadAction<string>) {
      state.open = true;
      state.severity = 'info';
      state.message = action.payload;
    },
    close(state) {
      state.open = false;
      delete state.severity;
      delete state.message;
    }
  }
});

export const { actions, reducer, name: sliceKey } = alertSlice;
export const { actions: AlertActions } = alertSlice;
